<template>
  <div class="site-managemanet">
    <v-row>
      <v-col cols="5">
        <template v-if="isStepBase">
          <form-base :data="formBase" @update="updateBaseForm"></form-base>
        </template>
        <template v-if="isStepSite">
          <v-row class="ma-0">
            <v-spacer></v-spacer>
            <v-col cols="auto">
              <v-btn color="primary" outlined="outlined">
                <v-icon left="left">mdi-plus</v-icon>{{ $t('formSite.addSite') }}
              </v-btn>
            </v-col>
            <form-site :data="station" @update="updateStationForm" v-for="station in stations" :key="station.id"></form-site>
          </v-row>
        </template>
      </v-col>
      <v-col cols="7">
        <v-row class="ma-0" v-if="isStepSite">
          <v-spacer></v-spacer>
          <v-col cols="auto">
            <v-btn :to="stepBaseLink" color="primary" outlined="outlined">
              <v-icon left="left">mdi-pencil</v-icon>{{ $t('formSite.editBase') }}
            </v-btn>
          </v-col>
        </v-row>
        <v-responsive :aspect-ratio="4/3">
          <google-map :zoom="range.zoom" :editable="editable" :paths.sync="insertPaths" :stations="stations" :center="range.position"></google-map>
        </v-responsive>
      </v-col>
    </v-row>
    <v-row>
      <v-spacer></v-spacer>
      <v-col cols="auto">
        <v-row class="ma-0" v-if="isStepBase">
          <v-col cols="6">
            <v-btn @click="back" color="secondary" large="large" min-width="160" outlined="outlined">{{ $t('buttons.back') }}</v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn to="/service-base/site-management/create?step=site" color="secondary" min-width="160" large="large">{{ $t('buttons.next') }}</v-btn>
          </v-col>
        </v-row>
        <v-row class="ma-0" v-else>
          <v-col cols="6">
            <v-btn @click="back" color="primary" large="large" min-width="160" outlined="outlined">{{ $t('buttons.back') }}</v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn to="/service-base/site-management" color="secondary" min-width="160" large="large">{{ $t('buttons.confirm') }}</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GoogleMap from '@/components/GoogleMap'
import EditPolygon from '@/mixins/EditPolygon'
import InsertPolygon from '@/mixins/InsertPolygon'
import SiteManagementStep from '@/mixins/SiteManagementStep'
import FormBase from '@/components/SiteManagement/Forms/Base'
import FormSite from '@/components/SiteManagement/Forms/Site'

export default {
  mixins: [SiteManagementStep, InsertPolygon, EditPolygon],
  components: { FormBase, FormSite, GoogleMap },
  data () {
    return {
      editable: false,
      formBase: {
        baseID: '',
        baseName: '',
        centerPositon: null,
        circumference: 0,
        sites: 0,
        bikeRacks: 0,
        startDate: ''
      }
    }
  },
  watch: {
    isStepBase (val) {
      this.editable = val
    },
    editable (val) {
      if (val) this.showPolygon()
    }
  },
  computed: {
    ...mapGetters({
      stations: 'station/list',
      range: 'range/data'
    }),
    stepBaseLink () {
      return this.$route.path + '?step=base'
    }
  },
  methods: {
    back () {
      this.$router.back()
    },
    updateBaseForm ({ field, value }) {
      this.formBase[field] = value
    },
    updateStationForm ({ id, field, value }) {

    }
  },
  mounted () {
    this.editable = this.isStepBase
  }
}
</script>
